import { render, staticRenderFns } from "./oneOption.vue?vue&type=template&id=2d684bf4&"
import script from "./oneOption.vue?vue&type=script&lang=js&"
export * from "./oneOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports